var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-user"}),_vm._v(" "),_c('span',{staticClass:"number-of-players"},[_vm._v(_vm._s(_vm.gameNumberOfPlayers))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbbf7e10","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/_default/_components/player-count/player-count.html
// module id = null
// module chunks = 